export default "__VITE_ASSET__BltKwM86__"